import { render, staticRenderFns } from "./StoreData.vue?vue&type=template&id=5c1b38c2&"
import script from "./StoreData.vue?vue&type=script&lang=js&"
export * from "./StoreData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports